export default __webpack_public_path__ + "assets/images/8285bc12b5fbb8dbd36f7a0790f12b0e.svg";